"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const Block_1 = require("./Block");
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
const settings_1 = require("../config/settings");
class IconButton extends Block_1.Block {
    constructor(app, text, sprite, padding = 8) {
        super(app);
        this.text = text;
        this.sprite = sprite;
        this.padding = padding;
        this.background = new pixi_js_1.Graphics();
        this._color = settings_1.Settings.lightLightGrayColor;
        this.addChild(this.background, this.text, this.sprite);
        this.sprite.texture.baseTexture.resource.load().then(() => {
            this.layout();
        });
    }
    set color(color) {
        this._color = color;
        this.layout();
    }
    set size(size) {
        this._size = size;
        this.layout();
    }
    layout() {
        super.layout();
        if (this._size) {
            this.sprite.anchor.set(0, 0.5);
            this.text.anchor.set(1, 0.5);
            this.text.position.set((0, Global_1.px)(this._size.width / 2 - 1), (0, Global_1.px)(this._size.height / 2));
            this.sprite.position.set((0, Global_1.px)(this._size.width / 2 + 2), (0, Global_1.px)(this._size.height / 2 - 2));
            this.makeBox({
                width: this._size.width,
                height: this._size.height,
                radius: 3,
                border: 2,
                backgroundColor: this._color
            }, this.background);
            this.pivot.set((0, Global_1.px)(this._size.width / 2), (0, Global_1.px)(this._size.height / 2));
        }
        else {
            const sheight = this.sprite.height + (0, Global_1.px)(this.padding * 2);
            this.text.position.set((0, Global_1.px)(this.padding), Math.max((0, Global_1.px)(this.padding), sheight / 2 - this.text.height / 2));
            this.sprite.position.set(this.text.x + this.text.width + (0, Global_1.px)(this.padding), (0, Global_1.px)(this.padding));
            const width = this.sprite.x + this.sprite.width + (0, Global_1.px)(this.padding);
            const height = Math.max(this.text.height, this.sprite.height) + (0, Global_1.px)(this.padding * 2);
            this.makeBox({
                width: (width / (0, Global_1.px)()),
                height: (height / (0, Global_1.px)()),
                radius: 3,
                border: 2,
                backgroundColor: this._color
            }, this.background);
            this.pivot.set(width / 2, height / 2);
        }
    }
}
exports.IconButton = IconButton;
